const _temp0 = require("url:../img/nav/amp-map.svg");
const _temp1 = require("url:../img/nav/arrow.svg");
const _temp2 = require("url:../img/nav/arrow_gray.svg");
const _temp3 = require("url:../img/nav/favoris.svg");
const _temp4 = require("url:../img/nav/fleche-vague.svg");
const _temp5 = require("url:../img/nav/fleche-vent.svg");
const _temp6 = require("url:../img/nav/fleches-stabilite-green.svg");
const _temp7 = require("url:../img/nav/fleches-stabilite-orange.svg");
const _temp8 = require("url:../img/nav/fleches-stabilite-red.svg");
const _temp9 = require("url:../img/nav/info.svg");
const _temp10 = require("url:../img/nav/legend.svg");
const _temp11 = require("url:../img/nav/meteo.svg");
const _temp12 = require("url:../img/nav/meteo_previ.svg");
const _temp13 = require("url:../img/nav/meteo_select.svg");
const _temp14 = require("url:../img/nav/meteogramme-prevision.svg");
const _temp15 = require("url:../img/nav/meteogramme.svg");
const _temp16 = require("url:../img/nav/temp.svg");
const _temp17 = require("url:../img/nav/tide-map.svg");
const _temp18 = require("url:../img/nav/tide.svg");
const _temp19 = require("url:../img/nav/waves-prevision.svg");
const _temp20 = require("url:../img/nav/waves.svg");
const _temp21 = require("url:../img/nav/webcam-map.svg");
const _temp22 = require("url:../img/nav/webcam.svg");
const _temp23 = require("url:../img/nav/wind.svg");
const _temp24 = require("url:../img/nav/wind_prevision.svg");
module.exports = {
  "amp-map": _temp0,
  "arrow": _temp1,
  "arrow_gray": _temp2,
  "favoris": _temp3,
  "fleche-vague": _temp4,
  "fleche-vent": _temp5,
  "fleches-stabilite-green": _temp6,
  "fleches-stabilite-orange": _temp7,
  "fleches-stabilite-red": _temp8,
  "info": _temp9,
  "legend": _temp10,
  "meteo": _temp11,
  "meteo_previ": _temp12,
  "meteo_select": _temp13,
  "meteogramme-prevision": _temp14,
  "meteogramme": _temp15,
  "temp": _temp16,
  "tide-map": _temp17,
  "tide": _temp18,
  "waves-prevision": _temp19,
  "waves": _temp20,
  "webcam-map": _temp21,
  "webcam": _temp22,
  "wind": _temp23,
  "wind_prevision": _temp24
}